




















































import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
// types
import { InstanceGroup } from "@/services/instances/types";

@Component
export default class InstanceGroupDetails extends Vue {
    @Prop() group!: InstanceGroup;
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    nameState = null as any;

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }

    // methods
    emitData() {
        this.$emit("detailsUpdated", this.group);
    }

    setState(state:boolean) {
        if (this.localCollapseState === state) return;
        this.localCollapseState = state;
    }

    isFormValid() {
        this.isNameValid();
        return this.$emit("detailsValid", !!this.group.name);
    }

    isNameValid() {
        this.nameState = !!this.group.name;
    }
}
